module.exports = __webpack_public_path__ + "img/136.16cca93d.png";